// src/apiConfigs.js
const apiConfigs = {
    backEndAPI: (arr_data, method) => {
        const storedToken = window.localStorage.getItem("laravel-token");
        return {
            method: method,
            mode: "cors",
            body: JSON.stringify(arr_data),
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + storedToken,
            },
        };
    },
};

export default apiConfigs;
